module.exports = __webpack_public_path__ + "files/8be2cd5f5952ff8a303798fb5a4c762b.svg";